<div class="card">
  <div class="card-header">
    <h4 class="card-title float-left" id="basic-layout-form">{{ 'users.title' | translate }}</h4>
    <div class="clear-float-left"></div>
    <br>
    <button [disabled]="!sectionPermission.CanAdd" class="btn btn-raised btn-primary float-right" (click)="openModal()">
      <i
        class="ft-plus-circle"></i> {{ hasDesktopView ? ('users.addNewButtonText' | translate) : ('buttons.newText' | translate) }}
    </button>
    <app-company-selection-list [ngClass]="companySelectionListClass" [active]="hasSelectCompanyPermission"
                                [hideLabel]="true" [selectCompanyText]="'users.selectCompanyPlaceHolder' | translate"
                                (companyChangedEvent)="handleCompanyChanged($event)"></app-company-selection-list>
    <input type='text' class="form-control form-control-sm filter-input"
           placeholder="{{'users.filterByNamePlaceHolder' | translate}}" (keyup)='searchFilter($event)'/>
    <app-boolean-toggle-filter class="d-none d-md-block filter-input"
                               [booleanToggleFilterText]="'users.showInActiveText' | translate"
                               (booleanToggleFilterChangedEvent)="handleBooleanToggleFilterChanged($event)"></app-boolean-toggle-filter>
  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">{{ field.displayName | translate }}
          </th>
          <th>{{ 'users.actionsFieldTitle' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let user of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <ng-template [ngIf]="user.IsActive">
            <td class="d-none d-sm-table-cell"><i class="circle bg-green"></i></td>
          </ng-template>
          <ng-template [ngIf]="!user.IsActive">
            <td class="d-none d-sm-table-cell"><i class="circle bg-red"></i></td>
          </ng-template>
          <td><i [ngClass]="user.UserGroupIcon"></i></td>
          <td class="d-none d-sm-table-cell">{{ user.FirstName || "-" }}</td>
          <td class="d-none d-sm-table-cell">{{ user.LastName || "-" }}</td>
          <td class="d-none d-xl-table-cell">{{ user.UserName || "-" }}</td>
          <td class="col-sm-3">{{ user.Email || "-" }}</td>
          <td class="d-none d-xl-table-cell">{{ user.Company.Name || "-" }}</td>
          <td class="d-none d-lg-table-cell">{{ user.TwoFactorEnabled || "-" }}</td>
          <td>
            <a *ngIf="sectionPermission.CanEdit" class="success" data-original-title=""
               title="{{'users.editUserTitle' | translate: user}}" (click)="openEditModal(user)">
              <i class="ft-edit-2 font-medium-3"></i>
            </a>
            <a *ngIf="sectionPermission.CanActivate && !user.IsActive && !user.IsReadOnly" class="succes"
               data-original-title="" title="{{'users.activateUserTitle' | translate: user}}" (click)="activate(user)">
              <i class="ft-check font-medium-3 ml-1"></i>
            </a>
            <a *ngIf="sectionPermission.CanDeactivate && user.IsActive && !user.IsReadOnly" class="danger"
               data-original-title="" title="{{'users.deactivateUserTitle' | translate: user}}"
               (click)="deactivate(user)">
              <i class="ft-eye-off font-medium-3 ml-1"></i>
            </a>
            <a *ngIf="hasResetPasswordPermission" class="warning" data-original-title=""
               title="{{'users.resetPasswordOfUserTitle' | translate: user}}" (click)="resetPassword(user.UserId)">
              <i class="ft-mail font-medium-3 ml-1"></i>
            </a>
            <a *ngIf="hasResetPreSharedKeyPermission" class="info" data-original-title=""
               title="{{'users.resetPreSharedKeyOfUserTitle' | translate: user}}" (click)="resetPreSharedKey(user)">
              <i class="icon-key font-medium-3 ml-1"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
</div>
